import { IntlShape } from 'react-intl'

export const getEditLabel = (intl: IntlShape): string => {
  return `${intl.formatMessage({ id: 'common-edit' })}`
}
